import * as Yup from 'yup';

export const SignUpMoreInfoSchema = Yup.object().shape({
  industryType: Yup.string()
    .min(1)
    .required('Please provide your industry type'),
  fleetSize: Yup.string()
    .min(1)
    .required('Please provide your fleet size'),
  routes: Yup.string()
    .min(1)
    .required('Please select your routes'),

  vehiclesType: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Please select at least one vehicle')
    .required('Please select your vehicles'),
});

export type SignUpMoreInfoDataType = Yup.InferType<typeof SignUpMoreInfoSchema>;

type InitialValues = {
  industryType: string;
  fleetSize: string;
  routes: string;
  vehiclesType: string[];
};

export const signUpMoreInfoInitialValues: InitialValues = {
  industryType: '',
  fleetSize: '',
  routes: '',
  vehiclesType: [],
};


export interface MoreInfoSliderInterface {
  fleetSize: string;
  routes: string;
  vehiclesType: string[];
};

